import React from "react";
import { colors } from "../../utils/constants";
import { SelectOption } from "../Select/SelectNew";

interface RadioInputPropType {
  onChangeFunc: (val: string) => void;
  value: string;
  placeholder?: string;
  isRequired?: boolean;
  errorMsg?: string;
  name?: string;
  label?: string;
  disabled?: boolean;
  readonly?: boolean;
  isDarkBg?: boolean;
  layout?: "vertical" | "horizontal";
  options: SelectOption[];
}
const RadioInputNew = ({
  onChangeFunc,
  value = "",
  label = "",
  isRequired = false,
  errorMsg = "",
  disabled = false,
  readonly,
  isDarkBg = false,
  layout = "vertical",
  options,
}: RadioInputPropType) => {
  return (
    <>
      {label ? (
        <label className="text-sm text-docsigna-blue-dark font-medium block w-full max-w-full mb-1">
          {label}
          {isRequired ? <span className="text-red-500">*</span> : null}
        </label>
      ) : null}
      <div className={`flex flex-wrap ${layout === "vertical" ? "flex-col" : "items-center"} gap-5 w-full min-h-[40px]`}>
        {options.map((option, index) => {
          return (
            <label key={index} className="relative">
              <input
                type={"radio"}
                readOnly={readonly}
                checked={value === option.value}
                disabled={disabled}
                style={disabled ? { backgroundColor: "rgb(156 163 175)", cursor: "not-allowed" } : {}}
                onChange={() => onChangeFunc(option.value)}
                className="general-radio bg-transparent"
              />
              <span className="text-base ml-2">{option.label}</span>
            </label>
          );
        })}
      </div>
      {errorMsg ? <p style={{ color: colors.Red }}>{errorMsg}</p> : <p></p>}
    </>
  );
};

export default RadioInputNew;
